import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "love-it-generic-icon, span[love-it-generic-icon]",
    templateUrl: "./generic-icon.component.html",
    styleUrls: ["./generic-icon.component.scss"],
    standalone: false
})
export class GenericIconComponent implements OnInit {
  @Input() selector: string;

  constructor() {}

  ngOnInit(): void {}

  get isBootstrapIcon(): boolean {
    return this.selector.startsWith("bi-");
  }

  get isFeatherIcon(): boolean {
    return this.selector.startsWith("fi-");
  }

  get name(): any {
    if (this.isFeatherIcon || this.isBootstrapIcon) {
      return this.selector.substring(3);
    }
    return this.selector;
  }
}
